import React, { useMemo } from 'react';
import cn from 'classnames';
import { Typography } from 'seagull';
import { InvoicesLine, EditLine, PaymentsLine, AgreementsLine, MailSentLine18 } from 'seagull/icons';
import { useStoreActions } from "../../../../contexts";
import { getActivityLogItemContent } from "./ActivityLogItem.utils";
import styles from "./ActivityLogItem.module.scss";
import { activityLogModel, timeModel } from "../../../../models";
export const activityIcons = {
  relationship: /*#__PURE__*/React.createElement(AgreementsLine, null),
  reminderSent: /*#__PURE__*/React.createElement(MailSentLine18, null),
  charge: /*#__PURE__*/React.createElement(PaymentsLine, null),
  invoice: /*#__PURE__*/React.createElement(InvoicesLine, null),
  service: /*#__PURE__*/React.createElement(EditLine, null)
};
export default function ActivityLogItem(props) {
  const {
    entry,
    vendorName,
    clientName,
    relationship,
    isFirst,
    isLast
  } = props;
  const {
    logBI
  } = useStoreActions();
  const isReminderEntry = activityLogModel.isAgreementEntry(entry) && activityLogModel.isReminderEntry(entry);
  const type = activityLogModel.type(entry);
  const id = activityLogModel.id(entry);
  const timestamp = activityLogModel.timestamp(entry);
  const iconType = isReminderEntry ? 'reminderSent' : type;
  const content = useMemo(() => {
    return getActivityLogItemContent({
      entry,
      vendorName,
      clientName,
      relationship,
      testid: "activity-log-".concat(activityLogModel.id(entry)),
      logBI
    });
  }, [entry, vendorName, clientName, relationship]);
  return content ? /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.date
  }, /*#__PURE__*/React.createElement(Typography, null, timeModel.formatDateWithTime(timestamp))), /*#__PURE__*/React.createElement("div", {
    className: styles.separator
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.line, {
      [styles.transparent]: isFirst
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.dot
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.line, {
      [styles.transparent]: isLast
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.card
  }, /*#__PURE__*/React.createElement("span", {
    "data-testid": "activity-log-".concat(id, "-icon-").concat(iconType)
  }, activityIcons[iconType]), /*#__PURE__*/React.createElement("div", null, Array.isArray(content) ? content.map((row, idx) => /*#__PURE__*/React.createElement(Typography, {
    key: idx
  }, row)) : /*#__PURE__*/React.createElement(Typography, null, content)))) : null;
}